export default __webpack_public_path__ + "static/media/662.81ec41f0.jpg";